module.exports = __webpack_public_path__ + "img/2.4c61bff2.png";